<template>
  <layout-page>
    <tabs-vertical :tab-index="currentTab">
      <b-tab-item
        value="tasks"
      >
        <template #header>
          <b-icon icon="check"></b-icon>
          <span>
            Tasks
            <badge-default v-if="tasksBadge" :count="tasksBadge"></badge-default>
          </span>
        </template>

        <up-next-tasks-desktop-tab v-if="currentTab === 'tasks'"></up-next-tasks-desktop-tab>
      </b-tab-item>

      <b-tab-item
        label="Appointments"
        value="appointments"
        icon="calendar"
      >
        <up-next-appointments-desktop-tab v-if="currentTab === 'appointments'"></up-next-appointments-desktop-tab>
      </b-tab-item>
    </tabs-vertical>
  </layout-page>
</template>

<script>
import { subscribeToChannel, unsubscribeToChannel } from '../../services/pusher';
import UpNextTasksDesktopTab from "./UpNextTasksDesktopTab";
import UpNextAppointmentsDesktopTab from "./UpNextAppointmentsDesktopTab";

export default {
  name: "UpNextPageDesktop",
  metaInfo () {
    return {
      title: this.metaTitle,
    }
  },
  components: {
    UpNextAppointmentsDesktopTab,
    UpNextTasksDesktopTab,
  },
  data() {
    return {
      currentTab: 'tasks',
    }
  },
  watch: {
    $route() {
      this.setTab();
    },
    currentTabs: function (newTab) {
      if(newTab !== this.$route.params.tab) {
        this.$router.replace({params: {tab: this.currentTab}});
      }
    }
  },
  created() {
    if (this.tasksBadge > 0) {
      this.currentTab = 'tasks';
    }

    this.setTab();
    this.subscribeToChannel();
  },
  computed: {
    metaTitle() {
      switch (this.currentTab) {
        case 'tasks':
          return 'Up Next Tasks';
        case 'appointments':
          return 'Up Next Appointments';
        default:
          return 'Up Next';
      }
    },
    tasksBadge() {
      return this.$store.getters.tasksBadge
    }
  },
  methods: {
    setTab() {
      if(this.$route.params.tab) {
        this.currentTab = this.$route.params.tab;
      } else {
        this.$router.replace({params: { tab: this.currentTab }});
      }
    },
    subscribeToChannel() {
      subscribeToChannel('upNext', this.$store.getters.account.id);
    },
  },
  beforeRouteLeave (to, from, next) {
    if (this.$store.state.isLoggedIn) {
      unsubscribeToChannel('upNext', this.$store.getters.account.id);
    }

    this.$store.commit('setRoot', { store: 'upNext', prop: 'appointments', data: [] });
    this.$store.commit('setRoot', { store: 'upNext', prop: 'incompleteTasks', data: [] });
    next();
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.header-container {
  position: relative;
}
</style>
